// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"Header_wrapper__2y58z","img":"Header_img__1pyz2"};